export const APP_LINKS = {
  home: 'https://teampay.onelink.me/MgYC/fouzq6tv',
  benefits: 'https://teampay.onelink.me/MgYC/betefit'
} as const
